// extracted by mini-css-extract-plugin
export default {"toggle":"toggle-view_toggle__eHeaL"};